import { BaseRestfulService } from "./base";
import { ServiceURL } from "./url";

export class UserService extends BaseRestfulService {
    async self(data) {
        return this.put(ServiceURL.user.self(), data);
    }
}
